import { Button, Tooltip , Progress} from "antd";
import { formatDate } from "../../../utility/formatDate";
import { EyeOutlined } from "@ant-design/icons";


export const getColumns = (navigate) => [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width:"10%",
    },
    {
      title: "Level",
      dataIndex: "courseLevel",
      key: "courseLevel",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      align: 'left',
      width:"25%",
      ellipsis: true,
          render: (text) => (
            <Tooltip title={text} placement="topLeft" mouseEnterDelay={0.3}>
              <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer" }}>
                {text || "N/A"}
              </div>
            </Tooltip>
          ),
    },
    {
      title: "Assigned By",
      dataIndex: "assignedBy",
      key: "assignedBy",
    },
    {
      title: "Deadline",
      dataIndex: "deadline",
      key: "deadline",
      render: (date) => formatDate(date, "DD MMM YYYY"),
    },
    {
      title: "Completion %",
      dataIndex: "completionPercentage",
      key: "completionPercentage",
      width: "180px",
      render: (progress) => (
        <Progress
          percent={Number(progress.toFixed(2))}
          size="small"
          strokeColor={progress >= 100 ? "#088A15" : "#1777FF"}
          showInfo={true}
          format={(percent) => (
            <span style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "12px" }}>
              {percent}%
            </span>
          )}
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Action",
      render: (_, record) => (
        <Tooltip title="View">
          <Button
            type="text"
            className="view-action-btn"
            icon={<EyeOutlined />}
            onClick={() => navigate(`/my-courses/course-content-user/${record.courseId}`)}
          />
        </Tooltip>
      ),
    },
  ];